/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import {LoadMore} from 'react-weui'
import SearchLiveroomItem from './SearchLiveroomItem'
import '../../styles/search/SearchLiveroom.css'

class SearchLiveroom extends React.Component {

    render() {
        const {search} = this.props;
        let list = search.liveroom_list.slice(0, 3);
        return (
            <div className={list.length < 3 ? 'search-page-liveroom_noaround' : 'search-page-liveroom'}>
                {list.map((item) => <SearchLiveroomItem liveroom={item} key={item.id}/>)}
            </div>
        )
    }
}

export default connect(state => ({
    search: state.search
}))(SearchLiveroom)


// WEBPACK FOOTER //
// ./src/components/search/SearchLiveroom.js